export function IconMap() {
  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 40 40"
      fill="none"
      className="flex-shrink-0"
    >
      <rect width="40" height="40" rx="6" fill="#EBFAFD" />
      <path
        d="M9 14V30L16 26L24 30L31 26V10L24 14L16 10L9 14Z"
        stroke="#9498FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M16 10V26"
        stroke="#9498FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M24 14V30"
        stroke="#9498FF"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
